import React from 'react';
import _ from 'lodash';
import { RadioList, RadioListItem } from 'scy/RadioList';
import { textOverflow, textRight } from 'scy/utils.mod.scss';
import { TextButton } from 'scy/buttons';
import { AccentH5, SecondaryBody } from 'scy/text';
import {
  fontSizeXS,
  secondary,
  sansSerifRegular
} from 'scy/text/styles.mod.scss';
import { flex } from 'scy/flex.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function AddressPicker({
  addresses,
  onChange,
  selectedAddress,
  edit
}) {
  return (
    <RadioList className={margin.bottom_sm}>
      {(addresses || []).map(address => (
        <RadioListItem
          key={address.clientId}
          name="saved-address"
          id={`saved-address-${address.clientId}`}
          onChange={() => onChange(address)}
          checked={
            selectedAddress
              ? selectedAddress.clientId === address.clientId
              : false
          }
          mainContentClass={`${textOverflow} ${padding.xxs}`}
          autoHeight
          title={[address.address, address.unit, address.zip]
            .filter(str => !_.isEmpty(str))
            .join(', ')}
          subtitle={
            address.shipping ? null : (
              <DeliveryNotes
                notes={address.notes}
                addDeliveryNotes={() => edit(address)}
              />
            )
          }
          aside={
            <Aside
              label={address.saved ? address.label : null}
              onClick={() => edit(address)}
            />
          }
        />
      ))}
    </RadioList>
  );
}

function Aside({ label, onClick }) {
  return (
    <div className={textRight}>
      {label && (
        <AccentH5 tag="div" uppercase>
          {label}
        </AccentH5>
      )}
      <SecondaryBody>
        <TextButton noUnderline type="button" onClick={onClick}>
          Edit
        </TextButton>
      </SecondaryBody>
    </div>
  );
}

function DeliveryNotes({ notes, addDeliveryNotes }) {
  return notes ? (
    <div className={`${flex} ${secondary} ${sansSerifRegular} ${fontSizeXS}`}>
      “<div className={textOverflow}>{notes}</div>”
    </div>
  ) : (
    <div className={`${secondary} ${sansSerifRegular} ${fontSizeXS}`}>
      <TextButton onClick={addDeliveryNotes}>Add Delivery Notes</TextButton>
    </div>
  );
}
